import { Failure } from '@mrhenry/failure';
import { formatDate } from '../helpers/date';
import { staticText } from '../static-text';
import { BookingRequest } from '../types/booking-request';


export type OptionStatus = 'OK' | 'INPUT_ERROR' | 'CONFLICTING_RESERVATION' | 'OPTION_ALREADY_HANDLED';

export async function getOption( state: BookingRequest ): Promise<OptionStatus | Failure> {
	// Validate the data.
	if ( !state.bookingData.houseId ) {
		return Failure.from( staticText.submittingOptionNoHouseSelectedFailureMessage );
	}

	if ( !state.bookingData.startOfStay ) {
		return Failure.from( staticText.submittingOptionNoDateSelectedFailureMessage );
	}

	if ( '' === state.personalDetails.fullName ) {
		return Failure.from( staticText.submittingOptionNoNameSelectedFailureMessage );
	}

	if ( '' === state.personalDetails.email ) {
		return Failure.from( staticText.submittingOptionNoEmailSelectedFailureMessage );
	}

	if ( '' === state.personalDetails.telephone ) {
		return Failure.from( staticText.submittingOptionNoTelephoneSelectedFailureMessage );
	}

	let optionStatus;
	try {
		const endpoint = new URL( '/graphql', 'https://' + window.Mr.theaddressesApiDomain );
		const response = await fetch( endpoint, {
			credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify( {
				query: `mutation getOption($input: OptionInput!) {
					takeOption(input: $input)
				}`,
				variables: {
					input: {
						propertyID: state.bookingData.houseId.toString(),
						startOfStay: formatDate( state.bookingData.startOfStay ),
						numberOfWeeks: Math.round( state.bookingData.numberOfNights / 7 ),
						numberOfGuests: state.bookingData.numberOfPersons,
						name: state.personalDetails.fullName,
						email: state.personalDetails.email,
						phoneNumber: state.personalDetails.telephone,
						feedbackAndQuestions: state.personalDetails.feedback,
					},
				},
			} ),
		} );

		if ( !response.ok ) {
			console.error( 'Error:', `${response.status}: ${response.statusText}` );

			return Failure.from( staticText.submittingOptionFailedNetworkMessage );
		}

		const data = await response.json();
		if ( data?.errors?.length ) {
			console.error( 'Error:', data.errors );

			return Failure.from( staticText.submittingOptionFailedNetworkMessage );
		}

		optionStatus = data.data.takeOption;
	} catch ( error ) {
		console.error( 'Error:', error );

		return Failure.from( staticText.submittingOptionFailedNetworkMessage );
	}

	if ( !optionStatus ) {
		return Failure.from( staticText.submittingOptionFailedNetworkMessage );
	}

	return optionStatus;
}
